import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { useAuth0 } from "./react-auth0-spa";
import history from "./utils/history";
import NavBar from "./components/NavBar";
import CallCenterStatistics from "./components/CallCenterStatistics";

function App() {
  const { loading } = useAuth0();

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <div className="App">
      <Router history={history}>
        <header>
          <NavBar />
        </header>
        <Switch>
          <Route path="/" component={CallCenterStatistics} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;